<template>
  <div v-if="visible">
    <dialog-reset
      title="地图"
      :visible.sync="visible"
      top="5%"
      width="1000px"
      height="70vh"
      :beforeClose="handleClose"
    >
      <iframe
        ref="dic-tian-di"
        class="iframeStyle"
        src="/cdn/tiandi/index.html"
        frameborder="0"
      ></iframe>
    </dialog-reset>
  </div>
</template>

<script>
export default {
  name: "TdMap",
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    initialLnglat: {
      //经纬度坐标
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      currentLocationInfo: {
        address: "",
        lnglat: [],
      },
    };
  },
  methods: {
    handleClose() {
      this.$emit("setEmit");
    },
  },
  mounted() {
    window.addEventListener(
      "message",
      (event) => {
        console.log()
        if (event.data.type === "isok") {
            console.log("接收到了消息isok")
            console.log(`this.$refs['dic-tian-di'].contentWindow`)
          this.$refs['dic-tian-di'].contentWindow.postMessage({
            type: "make",
            data: this.initialLnglat,
          },'*');
        }

        if (event.data.type === "click") {
          console.log("接收到了对应的消息:", event.data); // 处理接收到的消息
          console.log(`-0----`, this.currentLocationInfo);
          this.currentLocationInfo.lnglat = [
            event.data.data.longitude,
            event.data.data.latitude,
          ];
          this.currentLocationInfo.address = "厂区内部位置";
          this.$emit("location-selected", this.currentLocationInfo);
          this.$emit("setEmit");
        }
      },
      false
    );
  },
};
</script>

<style scoped lang="scss">
.iframeStyle {
  width: 100%;
  height: 100%;
  min-height: 650px;
}
</style>
